import React from 'react';
import {SortRounded, ViewCompactRounded} from '@mui/icons-material';
import {Stack, ToggleButton, ToggleButtonGroup, Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {SUGGESTIVE_SELLING_VIEW_MODES} from '../constants';

const SuggestiveSellingViewModeToggle = ({
                                             viewMode,
                                             onChange,
                                             disabled,
                                         }) => {
    const {t} = useTranslation('dialogs', {keyPrefix: 'app-specific.suggestive-selling'});

    return (
        <Stack
            sx={{
                border: '1px solid transparent',
                borderColor: 'divider',
                padding: 0.5,
                borderRadius: 1,
                width: 'fit-content',
                flexShrink: 0,
            }}
        >
            <ToggleButtonGroup
                disabled={disabled}
                size={'small'}
                exclusive
                value={viewMode}
                onChange={(_, value) => value && onChange(value)}
                sx={{
                    '& .MuiToggleButtonGroup-grouped': {
                        borderRadius: '0.5rem',
                        width: 30,
                        height: 30,
                    },
                    '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                        marginLeft: '.25rem',
                    },
                }}
            >
                <ToggleButton
                    value={SUGGESTIVE_SELLING_VIEW_MODES.list}
                    sx={{
                        backgroundColor: viewMode === SUGGESTIVE_SELLING_VIEW_MODES.list ? 'divider' : 'transparent',
                        border: 'none',
                    }}
                >
                    <Tooltip title={t('listView')}>
                        <SortRounded sx={{padding: 0.25}}/>
                    </Tooltip>
                </ToggleButton>
                <ToggleButton
                    value={SUGGESTIVE_SELLING_VIEW_MODES.grid}
                    sx={{
                        backgroundColor: viewMode === SUGGESTIVE_SELLING_VIEW_MODES.grid ? 'divider' : 'transparent',
                        border: 'none',
                    }}
                >
                    <Tooltip title={t('gridView')}>
                        <ViewCompactRounded sx={{padding: 0.25}}/>
                    </Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
};

export default SuggestiveSellingViewModeToggle;
